











































































































































































































































import BaseComponent from '@/components/base-component.vue';
import UiAutoCompleteAddress from '@/components/UI/autocomplete-address.vue';
import UiAutocompleteSubordinate from '@/components/UI/autocomplete-subordinate.vue';
import UiAutocompleteUF from '@/components/UI/autocomplete-uf.vue';
import UiCepTextField from '@/components/UI/cep-textfield.vue';
import UiComboboxIndividual from '@/components/UI/combobox-individual.vue';
import UiDatePicker from '@/components/UI/date-picker.vue';
import UiTimePicker from '@/components/UI/time-picker.vue';
import { ConflitoAgendaFiltros } from '@/interfaces/calendar';
import { AgendamentoVisitaParmDTO } from '@/interfaces/crm-visit-planning';
import * as service from '@/services/crm-visit-planning';
import { getLocalUser } from '@/services/session-data';
import { getServerISODate } from '@/services/utils';
import * as resize from '@/subjects/resize';
import moment from 'moment';
import { Observable } from 'rxjs';
import Component from 'vue-class-component';
import { Prop, Watch } from 'vue-property-decorator';
import CalendarConflictAlertDialog from '../calendar/calendar-conflict-alert-dialog.vue';
import ContactRelationshipTable from '../contact/contact-relationship-table.vue';
import UiSelectInstitution from '../institution/select-institution.vue';
import VisitPlanningCycle from './visit-planning-cycle.vue';

@Component({
  components: {
    UiSelectInstitution,
    UiDatePicker,
    UiComboboxIndividual,
    UiCepTextField,
    ContactRelationshipTable,
    UiAutocompleteSubordinate,
    UiTimePicker,
    UiAutocompleteUF,
    UiAutoCompleteAddress,
    VisitPlanningCycle,
    CalendarConflictAlertDialog
  }
})
export default class VisitPlanningForm extends BaseComponent {
  @Prop()
  id: number;

  @Prop()
  idInstitution: number;

  @Prop()
  date: string;

  @Prop({ default: false })
  edit: boolean;

  modalOpen = false;

  dto: any = { data: null, presencial: null, provisorio: false, urgente: false };
  endereco: any = {};
  contatos: any = [];
  chkEnderecoGoogle = false;
  enderecoGoogle = null;

  currentTab = 'tab-dados-base';

  smallScreen: boolean = resize.isXsOrSmSizeScreen();

  cycle = null;
  dateHint = null;
  minDate = null;

  conflictParms: ConflitoAgendaFiltros = null;
  formConflictOpened = false;  

  public form: any = {
    valid: false,
    rules: {
      data: [(v) => this.validatePlanningDate(v)],
      horario: [(v) => (!!v && v.length == 5) || 'Informe um horário válido'],
      instituicao: [(v) => !!v || 'Selecione a Instituição'],
      presencial: [(v) => v != null || 'Selecione a Modalidade'],
      logradouro: [(v) => !!v || 'Informe o logradouro'],
      numero: [(v) => !!v || 'Informe o número'],
      bairro: [(v) => !!v || 'Informe o bairro'],
      cidade: [(v) => !!v || 'Informe a cidade'],
      estado: [(v) => !!v || 'Informe o estado'],
      cep: [(v) => !!v || 'Informe o CEP'],
      objetivo: [(v) => (!!v && v.length > 4) || 'Informe o Objetivo'],
      visitantes: [(v) => (!!v && v.length > 0) || 'Selecione pelo menos um Consultor'],
      contatos: [(v) => (!!v && v.length > 0) || 'Selecione pelo menos um Contato']
    }
  };

  public $refs!: {
    form: HTMLFormElement;
  };

  mounted() {
    if (this.id == null) {
      setTimeout(() => {
        this.modalOpen = true;
      }, 50);
      getLocalUser().subscribe((res) => {
        this.dto.idsVisitantes = [res.idLogin];
      });
    }
    resize.windowSizeChanged$.subscribe((res) => {
      this.smallScreen = resize.isXsOrSmSizeScreen();
    });

    getServerISODate().subscribe((res) => {
      this.minDate = res;
    });
  }

  @Watch('id', { immediate: true })
  onIdChange(id) {
    if (!id) {
      return;
    }

    this.minDate = null;

    this.loader.start('Carregando ...');
    service.getCrmVisitPlanningDetails(id).subscribe(
      (res) => {
        this.dto = { ...res };
        this.endereco = this.dto.endereco;
        if (!this.endereco) {
          this.endereco = {};
        }
        this.contatos = this.dto.contatos;
        this.modalOpen = true;
        this.loader.stop();
        if (this.edit) {
          this.$refs.form.validate();
        }
      },
      (error) => {
        this.showToastApiError(error);
        this.close();
        this.loader.stop();
      }
    );
  }

  @Watch('idInstitution', { immediate: true })
  onIdInstitutionChange(id) {
    this.dto.idInstituicao = id;
    this.onInstitutionChange();
  }

  @Watch('date', { immediate: true })
  onDateChange(date) {
    this.dto.data = date;
  }

  public close(): void {
    this.$emit('close');
  }

  public save() {
    this.$refs.form.validate();

    if (!this.form.valid) {
      return;
    }

    let parm: AgendamentoVisitaParmDTO = this.prepareParms();

    let obs: Observable<any> = null;
    if (this.dto.id) {
      parm.id = this.dto.id;
      obs = service.updateCrmVisitPlanning(parm);
    } else {
      obs = service.saveCrmVisitPlanning(parm);
    }
    this.loader.start('Processando ...');
    obs.subscribe(
      (id) => {
        this.loader.stop();
        this.toast.show('Agendamento salvo com sucesso', 'success');
        this.$emit('afterSave', id);
      },
      (error) => {
        this.showToastApiError(error);
        this.loader.stop();
      }
    );
  }

  prepareParms() {
    let parm: AgendamentoVisitaParmDTO = Object.assign(new AgendamentoVisitaParmDTO(), this.dto);
    parm.provisorio = this.provisorio;
    if (parm.presencial) {
      parm.endereco = this.endereco;
    } else {
      parm.endereco = null;
    }
    if (this.contatos) {
      let contatos: any = Array.from(this.contatos);
      parm.idsContatos = contatos.map((c) => c.id);
    }
    return parm;
  }

  provisorio = false;

  preSave(provisorio) {
    this.provisorio = provisorio;
    this.$refs.form.validate();

    if (!this.form.valid) {
      return;
    }

    let parm = this.prepareParms();

    this.conflictParms = new ConflitoAgendaFiltros();
    this.conflictParms.tipoAlterando = 'AV';
    this.conflictParms.idAlterando = this.dto.id;
    this.conflictParms.dataIni = parm.data;
    this.conflictParms.dataFim = parm.data;
    this.conflictParms.horaIni = parm.horario;
    this.conflictParms.horaFim = parm.horario;
    this.conflictParms.idsLogins = parm.idsVisitantes;
    this.conflictParms.idInstituicao = parm.idInstituicao;

    this.formConflictOpened = true;      
  }

  onReturnSave() {
    this.formConflictOpened = false;
    this.save();
  }

  onReturnCancel() {
    this.formConflictOpened = false;
  }

  onCepResult(end) {
    if (!end) {
      return;
    }
    this.endereco = { ...this.endereco, ...end };
  }

  onInstitutionChange() {
    this.loadInstitutionDetails();
  }

  loadInstitutionDetails() {
    if (!this.dto.idInstituicao) {
      return;
    }
    service.getCrmVisitPlanningInstitution(this.dto.idInstituicao).subscribe(
      (res) => {
        this.endereco = res.endereco;
      },
      (error) => {
        this.showToastApiError(error);
      }
    );
  }

  onModalityChange() {
    this.loadInstitutionDetails();
  }

  @Watch('enderecoGoogle')
  onEnderecoGoogleChange(e) {
    if (!e) {
      return;
    }
    this.endereco = e;
  }

  onCycleLoaded(cycle) {
    if (cycle == null) {
      this.close();
    }
    this.cycle = cycle;
    this.dateHint = `O ciclo de planejamento atual permite agendamento com data a partir de ${this.cycle.dataMinPermitidaFmt}`;
    this.minDate = this.cycle.dataMinPermitida;

    if (this.dto.id && this.edit) {
      this.$refs.form.validate();
    }
  }

  validatePlanningDate(date: any) {
    if (!date) {
      return 'Informe uma data válida';
    }
    if (this.dto.urgente) {
      return true;
    }
    if (moment(this.minDate, 'YYYY-MM-DD').isAfter(moment(this.dto.data, 'YYYY-MM-DD'))) {
      return !!this.dateHint? this.dateHint : 'A data deve ser a partir de ' + this.dateFormatHelper(this.minDate, 'BR');
    }

    return true;
  }
}
